import React from "react";
import { Outlet } from "react-router-dom";
import  Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = () => {
  return (
    <>
      {/* <div className="hold-transition sidebar-mini layout-fixed sidebar-collapse"> */}
        <div className="wrapper">
          <Sidebar />
          <div className="content-wrapper">
            <Header />
            <main>
              <Outlet />
            </main>
          </div>
        </div>
      {/* </div> */}
    </>
  );
};

export default Layout;
